// check if "chat" in path
// const path      = to.path;
export default function(path) {
  const chatReExp = "\\/chat\\/";
  return path.match(chatReExp) !== null;
}

